<div class="field" soho-busyindicator [text]="' '" [transparentOverlay]="true" [overlayOnly]="true" [timeToComplete]="500">
  @if (label) {
    <label
      soho-label
      [required]="required$ | async"
      [attr.for]="id"
      [personalize]="personalize"
      lm-label
      [layoutField] = "field"
      [layoutInfo]="layoutInfo"
      [personalize]="personalize"
      lm-text-style [textStyle]="label?.textStyle"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
  }

  @switch (displayType) {
    @case (layoutDisplayType.PLAIN_LINK) {
      @if (valid) {
        @if (layoutObject.openInOverlay) {
          <!-- add a tooltip if open in overlay -->
          <a soho-hyperlink="{{hyperlinkType}}"
            [attr.tabindex]="0"
            [ngClass]="{'lm-hyperlink': !layoutObject.icon, 'lm-form-icon-button': layoutObject.icon && !layoutObject.title}"
            [attr.id]="id"
            [class.personalize-actionable]="personalize"
            (click)="onClickEvent($event)"
            (keydown.enter)="onClickEvent($event)"
            (keydown.control.enter)="onClickEvent($event)"
            (focusout)="onFieldBlur($event)"
            soho-alert
            soho-tooltip [content]="'FlyoutOpenFullScreen' | translate"
            >
              <ng-container *ngTemplateOutlet="hyperlinkInternals"></ng-container>
          </a>
        } @else {
          <a soho-hyperlink="{{hyperlinkType}}"
            [attr.tabindex]="0"
            [ngClass]="{'lm-hyperlink': !layoutObject.icon, 'lm-form-icon-button': layoutObject.icon && !layoutObject.title}"
            [attr.id]="id"
            [class.personalize-actionable]="personalize"
            (click)="onClickEvent($event)"
            (keydown.enter)="onClickEvent($event)"
            (focusout)="onFieldBlur($event)"
            soho-alert
            >
              <ng-container *ngTemplateOutlet="hyperlinkInternals"></ng-container>
          </a>
        }
      } @else {
        <p
          attr.id="{{id}}"
          [class.lm-text-data]="true"
          [class.hide-white-space]="true"
          [class.personalize-actionable]="personalize"
          [class.data]="true"
        >{{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}</p>
      }
    }
    @case (layoutDisplayType.MAIL_LINK) {
      <a href="{{triggerValueChange | async | formatMessageRule:true:layoutObject.httpUrl:model:specFields}}"
        soho-hyperlink="{{hyperlinkType}}"
        [class.personalize-actionable]="personalize"
        attr.aria-label="{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}} - {{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}"
        [attr.id]="id"
        [attr.tabindex]="0"
        soho-alert
        soho-tooltip [content]=""
        (mouseenter)="onMouseEnter()"
        (focusout)="onFieldBlur($event)"
      >{{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}</a>
    }
  }
</div>

<ng-template #hyperlinkInternals>
<!-- display link as text if there is no icon -->
  @if (!layoutObject.icon) {
    <span
      attr.aria-label="{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}} - {{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}"
    >{{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}</span>
  }
  <!-- display as icon if there is icon, use soho icon if icon name matches soho icon name -->
  @if (layoutObject.icon && !validSohoIcon  && !layoutObject.title) {
    <img class="icon" src="{{layoutObject.iconUrl}}" alt=""/>
    {{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}
  }
  @if (layoutObject.icon && validSohoIcon) {
    <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
      <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
    </svg>
    {{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}
  }
  @if (layoutObject.icon && !validSohoIcon && layoutObject.title) {
    <!-- decorative image, alt can be left blank since there's an adjacent info -->
    <img class="icon" src="{{layoutObject.iconUrl}}" alt=""/>
    {{triggerValueChange | async | formatMessageRule:true:textMessageRule:model:specFields}}
  }
</ng-template>
